const styles = theme => ({
  pagesContainer: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  sideBoxContainer: {
    [theme.breakpoints.down("md")]: {
      display: "inline"
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/PagesGrid/styles.js